import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { GetVoiceCallListDetailService } from '../../../services/admin/VoiceCallListServices';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import { AssignedFailedTemplateTargetListService, GetTemplateTargetListAnalyticsService, GetTemplateTargetListDetailService } from '../../../services/admin/TemplateTargetListServices';
import { ButtonOutlinedAutoWidth } from '../../../components/button';
import toast from 'react-hot-toast';

function TemplateTargetListDetail() {

  const navigator = useNavigate()

  const {state} = useLocation()


  const [data,setdata] = useState({})
  const [loader,setloader] = useState(false)
  const [timeDifference,settimeDifference] = useState(0)
  const [analytics,setanalytics] = useState([])
  const [selectedanalytics,setselectedanalytics] = useState({Delivered_user_list:[],Failed_user_list:[],Pending_user_list:[],handled_by:''})

  console.log("selectedanalytics",selectedanalytics)

  const [step,setstep] = useState('Data')

  const stages1 = ['Data','Analytics']

  const [stage,setstage] = useState('Delivered')
  const stages = ['Delivered','Failed','Pending','Pending With Error']

// FollowUp (3 Days)


  useEffect(() => {
    getdata()
  }, [state])

  async function getdata() {
    const response = await GetTemplateTargetListDetailService(state?._id)
    const response1 = await GetTemplateTargetListAnalyticsService(state?._id)

    setanalytics(response1?.data?.data)

    if(response1?.data?.data?.length > 0 ){
      setselectedanalytics(response1?.data?.data[0])
    }

    let d = response?.data?.datas[0]

    if(d?.createdAt){
      const createdAt = new Date(d.createdAt);
      const hoursCompleted = Math.floor(
        (Date.now() - createdAt.getTime()) / (1000 * 60 * 60)
      );
      settimeDifference(hoursCompleted)

    }

    setdata(response?.data?.datas?.length > 0 ? response?.data?.datas[0] : [])
  }


  async function downloadFailed() {

   let datas = stage === 'Pending With Error' ? data?.targeted_customer?.filter((f)=>f?.status === 'Pending' && f?.customer_chat_details?.errors?.length === 2) : data?.targeted_customer?.filter((f)=>f?.status === stage)
   const headers = ["S.No", "Full Name", "Mobile", "Status"];
   const rows = datas.map((d, i) => [i + 1, d.customer_details?.name, d.customer_details?.mobile,d?.status]);

  const csv =
    headers.join(",") + "\n" +
    rows.map(r => r.join(",")).join("\n");

  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "custom.csv";
  a.click();
  }
  // console.log("data",data)


  const filteredData =
  stage === "Pending With Error"
    ? data?.targeted_customer?.filter(
        (f) => f?.status === "Pending" && f?.customer_chat_details?.errors?.length === 2
      )
    : data?.targeted_customer?.filter((f) => f?.status === stage);


   const filteredData1 = (() => {
  if (!selectedanalytics) return [];

  if (stage === "Delivered") return selectedanalytics.Delivered_user_list || [];
  if (stage === "Failed") return selectedanalytics.Failed_user_list || [];
  if (stage === "Pending") return selectedanalytics.Pending_user_list || [];

  // ALL
  const allUsers = [
    ...(selectedanalytics.Delivered_user_list || []),
    ...(selectedanalytics.Failed_user_list || []),
    ...(selectedanalytics.Pending_user_list || [])
  ];

  // Remove duplicates by customer_id
  const uniqueUsers = Object.values(
    allUsers.reduce((acc, user) => {
      acc[user.customer_id] = user;
      return acc;
    }, {})
  );

  // console.log("uniqueUsers",uniqueUsers)

  // Filter condition
  return uniqueUsers.filter(
    u => u?.customer_chat_details?.errors?.length === 2
  );
})();


  async function validateAssign(){
    setloader(true)
    const response = await AssignedFailedTemplateTargetListService(state?._id)
    if(response?.status === 200){
      toast.success("Assigned Successfully!")
      getdata()
    }
    setloader(false)
  }
  
    console.log("analytics",analytics)
  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

   

      <div className='md:flex'>
        <div>
          <SettingsMenu  />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center py-2 border-b justify-between pb-3'>
            <div className='flex w-[98%] items-center  justify-between'>
            <h6 className='font-[800] text-[13px] w-[60%]'>Template Message Target Customer ({data?.targeted_customer?.length}) - {state?.campaign?.name}</h6>

            <div className='flex'>
            <div className='text-[11px] cursor-pointer flex items-center mr-2 font-[600] border rounded'>
              {stages1?.map((s)=><h6 onClick={()=>setstep(s)} className={`p-1 px-2 ${step === s && 'bg-yellow-600'}`}>{s}</h6>)}
            </div>
            
     
            {(timeDifference > 6 && (!data?.data_transfer)) && <ButtonOutlinedAutoWidth onClick={()=>!loader && validateAssign()} btnName="Assign Pending & Error Data" />}


            {step === 'Data' &&
            <h6 onClick={downloadFailed} className='bg-slate-100 ml-2 cursor-pointer border rounded font-[600] w-max border-slate-300 text-[12px] px-1 py-1 '>Download List</h6>}
            </div>


           
            </div>

          
          </div>


         
          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>


            {step === 'Data' && <>
              <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
                  {stages?.map((s)=>(
                  <h6 onClick={()=>{setstage(s)}} className={`font-[600] ${stage === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
                  ))}
              </div>
              {data?.targeted_customer?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                  <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                  <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                  <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}
              <div className='w-[100%] overflow-hidden'>
                {data?.targeted_customer?.length > 0 &&
                  <>
                  <h6 className='text-[12px] mt-2'>Total Data : <span className='font-[800]'>{filteredData?.length}</span></h6>
                  <div className='md:max-h-[85vh] mt-2 md:overflow-auto border-t border-l border-r'>
                    <div className='sticky top-0 z-50 flex w-max md:w-[100%]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Client Info</h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile </h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Status</h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[250px] w-[250px]  md:min-w-[250px]  md:w-[250px]  px-2 py-1 font-[600] text-slate-800 border-r'>Template</h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px]  px-2 py-1 font-[600] text-slate-800 border-r'>Campaign</h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[311.5px] w-[311.5px]  md:min-w-[311.5px]  md:w-[311.5px]  px-2 py-1 font-[600] text-slate-800 border-r'>Errors</h6>
                    </div>
                    {filteredData?.map((d, i) => (
                      <div className='flex w-max md:w-[100%] text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                        <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]   px-2 py-1 font-[500] border-r flex items-start justify-center'>{i + 1}</h6>
                        <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  md:min-w-[180px] md:w-[180px] px-2 py-1 border-r'>
                          <span className='font-bold'>{d?.customer_details?.name}</span>
                        
                        </h6>
                        <h6 className=' text-[12px] break-word min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px] px-2 py-1 font-[500] border-r'>
                          <span className='font-bold'>{d?.customer_details?.mobile}</span><br></br>
                        </h6>
                        <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[500] border-r'>
                        {d?.status}
                        </h6>

                        <h6 className=' text-[11px] break-all min-w-[250px] w-[250px]  md:min-w-[250px]  md:w-[250px]  px-2 py-1 font-[500] border-r'>
                        {d?.customer_chat_details?.localMessageId}
                        </h6>

                        <h6 className=' text-[12px] capitalize break-all min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px]  px-2 py-1 font-[500] border-r'>
                        {d?.customer_chat_details?.message_sent_type}
                        </h6>

                        <h6 className=' text-[12px] break-all min-w-[300px] w-[300px]  md:min-w-[300px]  md:w-[300px]  px-2 py-1 font-[500] border-r'>
                        <h6 className='bg-slate-100 p-1 text-[12px]'>Retry Count : <b>{d.customer_chat_details?.retry_count}</b></h6>
                        {d?.customer_chat_details?.errors?.map((e)=> 
                        <>
                        <h6 className='text-[11px]'>{e}</h6>
                        </>
                        )}
                        </h6>
                      
                      
                      </div>))}
                  </div>
                  </>}
              </div>
            </>}

            {step === 'Analytics' && 
            <>

            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
             {analytics?.map((a)=>(
              <h6 onClick={()=>setselectedanalytics(a)} className={`font-[600] ${selectedanalytics?.handled_by?._id === a?.handled_by?._id && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{a?.handled_by?.name}</h6>
              ))}
            </div>
            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
              {stages?.map((s)=>(
              <h6 onClick={()=>{setstage(s)}} className={`font-[600] ${stage === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
              ))}
            </div>

             {/* <h6 className='text-[12px] mt-2'>Total Data : <span className='font-[800]'>{filteredData?.length}</span></h6> */}
                  <div className='md:max-h-[85vh] mt-2 md:overflow-auto border-t border-l border-r'>
                    <div className='sticky top-0 z-50 flex w-max md:w-[100%]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Client Info</h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile </h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Status</h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[250px] w-[250px]  md:min-w-[250px]  md:w-[250px]  px-2 py-1 font-[600] text-slate-800 border-r'>Template</h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px]  px-2 py-1 font-[600] text-slate-800 border-r'>Campaign</h6>
                      <h6 className='sticky top-0 z-50  text-[12px]  min-w-[311.5px] w-[311.5px]  md:min-w-[311.5px]  md:w-[311.5px]  px-2 py-1 font-[600] text-slate-800 border-r'>Errors</h6>
                    </div>

                     {filteredData1?.map((d, i) => (
                      <div className='flex w-max md:w-[100%] text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                        <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]   px-2 py-1 font-[500] border-r flex items-start justify-center'>{i + 1}</h6>
                        <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  md:min-w-[180px] md:w-[180px] px-2 py-1 border-r'>
                          <span className='font-bold'>{d?.customer_details?.name}</span>
                        
                        </h6>
                        <h6 className=' text-[12px] break-word min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px] px-2 py-1 font-[500] border-r'>
                          <span className='font-bold'>{d?.customer_details?.mobile}</span><br></br>
                        </h6>
                        <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[500] border-r'>
                        {d?.status}
                        </h6>

                        <h6 className=' text-[11px] break-all min-w-[250px] w-[250px]  md:min-w-[250px]  md:w-[250px]  px-2 py-1 font-[500] border-r'>
                        {d?.customer_chat_details?.localMessageId}
                        </h6>

                        <h6 className=' text-[12px] capitalize break-all min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px]  px-2 py-1 font-[500] border-r'>
                        {d?.customer_chat_details?.message_sent_type}
                        </h6>

                        <h6 className=' text-[12px] break-all min-w-[300px] w-[300px]  md:min-w-[300px]  md:w-[300px]  px-2 py-1 font-[500] border-r'>
                        <h6 className='bg-slate-100 p-1 text-[12px]'>Retry Count : <b>{d.customer_chat_details?.retry_count}</b></h6>
                        {d?.customer_chat_details?.errors?.map((e)=> 
                        <>
                        <h6 className='text-[11px]'>{e}</h6>
                        </>
                        )}
                        </h6>
                      
                      
                      </div>))}
                  </div>   

            

            </>}

          </div>

        </div>
      </div>
    </div>
  )
}

export default TemplateTargetListDetail